
import { defineComponent, PropType } from 'vue'
import { getColor, getIcon, getTooltip } from '~/functions/esg'

export default defineComponent({
  props: {
    items: {
      type: Array as PropType<any[]>,
      required: true,
    },
    loading: {
      type: Boolean,
      required: true,
    },
    headers: {
      type: Array as PropType<any[]>,
      required: true,
    },
  },
  setup() {
    return {
      getColor,
      getIcon,
      getTooltip,
    }
  },
})
